import styled from "@emotion/styled";
import {Card} from "@mui/material";

export const SpacedCard = styled(Card)`
        margin-bottom: 1rem;
`
